import React from "react";
import { SvgIcon, SvgIconProps } from "module/common/component/display";
export function GlobeIcon(props: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...props} data-testid="GlobeIcon">
            <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" fill="none" stroke="currentColor" strokeWidth="1.5" />
            <path d="M12 2c-3 0-5.5 4.477-5.5 10S9 22 12 22s5.5-4.477 5.5-10S15 2 12 2z" fill="none" stroke="currentColor" strokeWidth="1.5" />
            <path d="M2.5 9h19M2.5 15h19" fill="none" stroke="currentColor" strokeWidth="1.5" />
        </SvgIcon>
    );
}
